import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from './Button';

import { setLevelID, setMoves, removeGoal, setLevel, setPalette } from '../actions';
import { palettes, PROPERTIES } from '../utilities';

class Editor extends Component {

  componentWillReceiveProps({goal}) {
    if (goal != null) {
      let goals = [...this.state.goals];
      let primaryGoal = {...goals[0]};
      if (primaryGoal[goal] === undefined) {
        primaryGoal[goal] = 1;
        goals[0] = primaryGoal;
        this.setState({goals});
      }
      this.props.removeGoal();
    }
  }

  state = {
    paletteKey : 'Set2',
    paletteDepth : 8,
    level : '',
    moves : '',
    formatted: true,
    goals : [{}],
    targetedSquare : '',
  }

  setJSON(json) {
    let level = JSON.parse(json);
    level.squares = {...level.squares, ...level.children};
    const levelID = level.level;
    level.level = 'editor';
    this.props.setLevel(level);
    this.setLevel(levelID);
    this.setMoves(level.moves);
    this.setState({goals : level.goal});
  }

  setLevel(level) {
    this.setState({level});
  }

  setMoves(moves) {
    this.setState({moves});
  }

  setGoals(goals) {
    let parsed = goals.split(/\n/).reduce( (goals, line) => {
      let [level, key = 'X', val = 0] = line.split(/\s*:\s*/);
      if (goals[level] === undefined) {
        goals[level] = {};
      }
      goals[level][key] = parseInt(val,10);
      return goals;
    }, []);
    this.setState({goals : parsed});
  }

  renderGoals(goals) {
    return goals.map( (oneGoal, level) => {
      return Object.keys(oneGoal).map( key => {
        return `${level}:${key}:${oneGoal[key]}`;
      }).join("\n")
    }).join("\n");
  }

  setFormatted(formatted) {
    this.setState({formatted});
  }

  setPaletteKey (paletteKey) {
    let newState = { paletteKey };
    if (!palettes[paletteKey][this.state.paletteDepth]) {
      newState.paletteDepth = 8;
    }
    this.setState(newState, () => {
      this.props.setPalette(palettes[this.state.paletteKey][this.state.paletteDepth]);
    });

  }

  setPaletteDepth(paletteDepth) {
    this.setState({ paletteDepth }, () => {
      this.props.setPalette(palettes[this.state.paletteKey][this.state.paletteDepth]);
    });
  }

  renderJSON(level, squares) {
    if (!squares) { return '' }

    const maxsquare_id = Math.max(...Object.keys(squares));
    
    var obj = Object.keys(squares).reduce( (acc, square_id) => {
      const square = squares[square_id];
      //console.log("CHECKS SQUARE : ", square.id, square.parent_id, parent);
      if (! square.parent_id || squares[square.parent_id].empty) {
        //console.log("ADDS TO SQUARE : ", square.id);
        acc.squares[square.id] = square;
      }
      else {
        if (acc.children[square.parent_id] === undefined) {
          acc.children[square.parent_id] = [];
        }
        acc.children[square.parent_id].push(square);
      }
      return acc;
    },
    {
      ...this.props.level,
      squares : {},
      children : {},
      level : this.state.level,
      moves : this.state.moves,
      goal : this.state.goals,
      maxsquare_id,
      palette : palettes[this.state.paletteKey][this.state.paletteDepth]
    });
//console.log("OBJ : ", obj, level);
    return JSON.stringify(obj, null, this.state.formatted ? 2 : undefined);
  }

  render() {
    if (! this.props.editor) { return null };

    return (
      <div style={{float : 'right', textAlign : 'left'}}>
        <div className='container-fluid'>
          <div className='row'>
            <div className='col'>
              { this.props.level.animals.map( (animal, idx) => <Button key={animal} width='32' height = '48' icon = {animal} tool = {animal} field='animal' value = {idx} svg={true} /> )}
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <select onChange={(e) => this.setPaletteKey(e.target.value)} className='form-control' value={this.state.paletteKey}>
                { Object.keys(palettes).sort().map( palette => <option value={palette} key={palette}>{palette}</option> ) }
              </select>
            </div>
            <div className='col'>
              <select onChange={(e) => this.setPaletteDepth(e.target.value)} className='form-control' value={this.state.paletteDepth}>
                { Object.keys(palettes[this.state.paletteKey]).map( depth => <option value={depth} key={depth}>{depth}</option> ) }
              </select>
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              { palettes[this.state.paletteKey][this.state.paletteDepth].map( (color, idx) => <Button key={color} width='32' height = '48' fill={color} tool = {color} field='fill' value = {idx} svg={true} /> )}
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <Button width='32' height = '48' icon = 'eraser' tool='eraser' field='eraser' value = 'eraser' svg={true}/>
              <Button width='32' height = '48' icon = 'star' tool='star' field='star' value = 'star' svg={true}/>
              <Button width='32' height = '48' icon = 'expand' tool='expand' field='expand' value = 'expand' svg={true}/>
              <Button width='32' height = '48' icon = 'collapse' tool='collapse' field='collapse' value = 'collapse' svg={true}/>
              <Button width='32' height = '48' icon = 'lock' tool='lock' field='lock' value = 'lock' svg={true}/>
              <Button width='32' height = '48' icon = 'arrow' tool = 'left' field='direction' value = {-1} rotate='180' svg={true} />
              <Button width='32' height = '48' icon = 'arrow' tool = 'down' field='direction' value = {0} rotate='90' svg={true} />
              <Button width='32' height = '48' icon = 'arrow' tool = 'right' field='direction' value = {1} svg={true} />
            </div>
          </div>
          <div className='row'>
            <div className='col'>Level:</div>
            <div className='col'><input type = 'text' value = {this.state.level} onChange={e => this.setLevel(e.target.value)} /></div>
          </div>
          <div className='row'>
            <div className='col'>Moves:</div>
            <div className='col'><input type = 'text' value = {this.state.moves} onChange={e => this.setMoves(e.target.value)} /></div>
          </div>
          <div className='row'>
            <div className='col'>
              <Button width='32' height = '48' badge = 'goal' icon='goal' tool = 'goal' value = 'goal' svg={true} />
              { PROPERTIES.join('/') }
            </div>
            <div className='col'>
              <textarea
                className='form-control'
                value={ this.renderGoals(this.state.goals) }
                onChange={(e) => this.setGoals(e.target.value)}
                rows='5'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col'>
              <textarea
                className='form-control'
                value={ this.renderJSON( this.props.level, this.props.squares ) }
                rows='10'
                onChange={(e) => this.setJSON(e.target.value)}/>
            </div>
          </div>
          <div className='row'>
            <div className='col'>Formatted:</div>
            <div className='col'><input type = 'checkbox' checked={this.state.formatted} onChange={e => this.setFormatted(e.target.checked)} /></div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({squares, level, goal}) => {
  return { squares, level, goal };
}

export default connect(mapStateToProps, {setLevelID, setLevel, setMoves, removeGoal, setPalette})(Editor);



// WEBPACK FOOTER //
// ./src/components/Editor.js